import Styled from "styled-components";

const LayoutWrap = Styled.div`
.ant-layout-header{
padding: 0 30px;
}
.side_bar{
   height:100%;
   transition: 1s;
  -webkit-transition: all 500ms ease-in-out;
}

 .logo_Style{
    margin: 24px;
    transition: 1s;
    -webkit-transition: all 500ms ease-in-out;
 }
 
 .Logo_txt{
   margin: 26px 23px 0px -13px;
  
 }
 .total_body{
     height: 100%;
 }
 .demo-logo-vertical{
   display: flex;
 }
 .ant-layout.ant-layout-has-sider{
    height: 100vh !important;
 }
 .ant-layout .ant-layout-sider{
   background-color: #061C06;
 }
 .ant-menu-dark{
   background-color: #061C06;
 }
 .ant-menu-dark.ant-menu-inline .ant-menu-sub{
  background-color: #061C06;
 }
 .ant-menu-dark .ant-menu-item-selected{
  opacity: 2.5 !important;
  background-color: #363636 !important;
  border-right: solid #2C963D 4px;
 }
 :where(.css-dev-only-do-not-override-11lehqq).ant-btn-text:not(:disabled):not(.ant-btn-disabled):hover{
   background: transparent  !important;
 }
 .ant-menu-item {
  opacity: 0.5; 
  transition: opacity 0.3s ease; 
 }
 .headericon{
  display: flex;
  justifyContent: flex-end;
  alignItems: center;
  gap: 16px;

          
 }


  @media (min-width: 320px) and (max-width: 426px) {
    
.main-content{
    /* background: rgb(241, 241, 241) !important; */
        /* background:gray!important;

     height:350px !important;
     overflow-y: scroll; */
}
  }

.main-content{
    background: rgb(241, 241, 241) !important;
     height: calc(100% - 70px);
  
}
     .ant-btn-icon{
     display: none;
     outline: none !important
     height: 14px;
     display:flex;
     align-items: center;
     justify-content-center
     }
.arrow-left{
   transition: 0.5s;
}
.arrow-right{
   transition: 0.5s;
}
 .side-bar{
 
 
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background-color:#000;
}
::-webkit-scrollbar-thumb {
  background-color:#ccc;
  border-radius: 6px;
  font-size: 16px;
}
}
.mainstyle{
 background-color:white;
 padding:15px;
 border-radius:10px;
 }

.ant-input-affix-wrapper {
border-radius: 17px !important;

}
`;
export default LayoutWrap;
